import { useEffect } from "react";
import { useRef } from "react";
import { useDispatch } from "react-redux";
import { toggleHeaderFixed, setHeaderCoordinates } from "redux/actions/App";

import useResizeObserver from "hooks/App/Observers/ResizeObserver";
import useIntersectionObserver from "hooks/App/Observers/IntersectionObserver";


export default function useModuleHeader() {

    const headerRef = useRef();
    const dispatch = useDispatch();

    const handleIntersection = (entries) => {
        const [entry] = entries;

        dispatch(toggleHeaderFixed(!entry.isIntersecting));

        const { x, y, width } = entry.target.getBoundingClientRect();
        dispatch(setHeaderCoordinates({ top: y, left: x, width }));
    };

    const handleResize = (entries) => {
        const entry = entries.slice(-1)[0];
        const { x, y, width } = entry.target.getBoundingClientRect();
        dispatch(setHeaderCoordinates({ top: y, left: x, width }));
    };

    useEffect(() => {
        dispatch(toggleHeaderFixed(false));
    }, []);

    useResizeObserver(headerRef.current, handleResize);
    useIntersectionObserver(headerRef.current, handleIntersection);

    return {
        headerRef,
    }

}